import { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { StarIcon } from '@phosphor-icons/react/dist/ssr/Star'
import { StopIcon } from '@phosphor-icons/react/dist/ssr/Stop'

import { AdaptedProduct } from '@/types'

export const RatingCellRenderer = memo(
  ({
    value,
    type = 'star',
  }: ICellRendererParams<AdaptedProduct> & {
    type?: string
  }) => {
    const Icon = type === 'star' ? StarIcon : StopIcon

    const rating = value?.value || value
    const relative = typeof rating === 'string' ? rating?.split('/') : []
    const isRelativeProp = relative?.length > 1 // true: value/relativity pair, false: single value
    const isRelativeValue = relative?.[1] === '0' // 0 means relative, 1 means absolute
    const ratingValue = isRelativeProp ? relative[0] : rating

    const ratingInt = Number(ratingValue)
    const maxStars = isRelativeProp ? [1, 2, 3] : [1, 2, 3, 4]

    if (isNaN(ratingInt)) return

    if (isRelativeProp) {
      const StarIcon = isRelativeValue ? (
        <Icon className={`h-4 w-4 text-slate-300`} />
      ) : (
        <Icon className={`h-4 w-4 text-slate-500`} weight="fill" />
      )

      return (
        <div className="flex h-full flex-row">
          <div className="flex flex-row items-center">
            {Array.from({ length: Number(relative[0]) }, (_, i) => (
              <span key={i}>{StarIcon}</span>
            ))}
          </div>
        </div>
      )
    }

    return (
      <>
        {ratingValue ? (
          <div className="flex h-full flex-row">
            <div className="flex flex-row items-center">
              {maxStars.map((i) => {
                return (
                  <div key={i} className="flex flex-row items-center">
                    {i - 1 < ratingValue ? (
                      <Icon
                        className={`h-4 w-4 text-slate-500`}
                        weight="fill"
                      />
                    ) : (
                      <Icon className={`h-4 w-4 text-slate-300`} />
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          ''
        )}
      </>
    )
  },
)

RatingCellRenderer.displayName = 'RatingCellRenderer'
